import { isOrderPaidBySquareOrAdmin } from "./adminOrderPaymentStatus";

export const PAID_ORDER_DELETE_CONFIRMATION = "确认删除订单";

export function containsPaidAdminOrder(orders = []) {
  return orders.some((order) => isOrderPaidBySquareOrAdmin(order));
}

export function promptForPaidOrderDeletion(orderCount = 1) {
  const targetText = orderCount > 1 ? `选中的 ${orderCount} 个订单中包含已付款订单` : "此订单已付款";
  const confirmationText = window.prompt(
    `${targetText}。删除后仍需人工处理退款和账务。\n请输入「${PAID_ORDER_DELETE_CONFIRMATION}」才能删除：`
  );

  if (confirmationText === PAID_ORDER_DELETE_CONFIRMATION) {
    return confirmationText;
  }
  if (confirmationText !== null) {
    window.alert(`输入不正确，请完整输入「${PAID_ORDER_DELETE_CONFIRMATION}」`);
  }
  return null;
}
